module.exports = "https://redage.akamaized.net/src/views/player/documets/fib/images/fib_logo.png";